import { styled } from 'baseui'

export const FiltersRow = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '1rem',
  marginBottom: '1rem',
})

export const FilterField = styled('div', {
  width: '15rem',
})

export const ActionsRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: '0.75rem',
})

export const TypesRow = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
})

export const PaginationRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '0.75rem',
  marginTop: '0.75rem',
})
